import ky from 'ky';

import { TB_SNAPSHOTS_BASE_URL } from './snapshots.constants';

export async function checkIsSnapshotAvailable() {
    try {
        await ky.get(`${TB_SNAPSHOTS_BASE_URL}/health`, { timeout: 1000 });

        return true;
    } catch {
        return false;
    }
}

export async function createSnapshot(content: string) {
    return ky
        .post(TB_SNAPSHOTS_BASE_URL, {
            json: {
                snapshotContent: content
            }
        })
        .json<{
            snapshotId: string;
        }>();
}

export async function getSnapshot(snapshotId: string) {
    return ky.get(`${TB_SNAPSHOTS_BASE_URL}/${snapshotId}`).json<{
        snapshotContent: string;
    }>();
}
